module.exports = __webpack_public_path__ + "media/images/new_home/sponsor-logo-3-c3247aaf7cdd25c20c2a8900ee2f78ce.png";